import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Form,
  FormGroup,
  FormField,
  Dropdown
} from 'semantic-ui-react'
import {
  DateTextBox
} from 'react-lib/apps/common'
import {
  Table
} from 'react-lib/frameworks/Table'

const CardTrainingHistoryUX = (props: any) => {
    return(
      <div
        style={{padding: "10px"}}>
        <Form
          className="small"
          id="CardEmployeeSummaryWorkHourUX-Form-1">
          <FormGroup
            id="CardEmployeeSummaryWorkHourUX-FormGroup-2"
            inline={true}>
            <FormField
              id="CardEmployeeSummaryWorkHourUX-FormField-6"
              inline={true}
              width={4}>
              <label
                id="CardEmployeeSummaryWorkHourUX-label-7"
                style={{minWidth: "max-content"}}>
                {props.languageUX === "en" ? "Search Course :" : "ค้นหาหลักสูตร :"}
              </label>
              <div
                id="CardCourseListUX-div-45"
                style={{width: "100%"}}>
                {props.courseSearchBox}
              </div>
            </FormField>
            <FormField
              id="CardEmployeeTimeAttendanceUX-FormField-20"
              inline={true}
              width={3}>
              <label
                id="CardEmployeeTimeAttendanceUX-label-28"
                style={{minWidth: "max-content"}}>
                {props.languageUX === "en" ? "Type :" : "พิมพ์ :"}
              </label>
              <Dropdown
                clearable={true}
                fluid={true}
                id="CardEmployeeTimeAttendanceUX-Dropdown-27"
                name="training_type"
                onChange={props.onChangeFilter}
                options={props.typeOptions}
                search={true}
                selection={true}
                style={{width: "100%"}}
                value={props.filter?.training_type ?? ""}>
              </Dropdown>
            </FormField>
            <FormField
              id="CardEmployeeTimeAttendanceUX-FormField-21"
              inline={true}
              width={3}>
              <label
                id="CardEmployeeTimeAttendanceUX-label-33"
                style={{minWidth: "max-content"}}>
                {props.languageUX === "en" ? "Course start date" : "หลักสูตร ตั้งแต่วันที่"}
              </label>
              <div
                id="CardEmployeeTimeAttendanceUX-div-29"
                style={{width: "100%"}}>
                
                <DateTextBox
                  id="CardEmployeeTimeAttendanceUX-DateTextBox-31"
                  onChange={(value: any)=>props.onChangeFilter?.(null,{name: "course_start_date_from", value})}
                  value={props.filter?.course_start_date_from}>
                </DateTextBox>
              </div>
            </FormField>
            <FormField
              id="CardEmployeeTimeAttendanceUX-FormField-22"
              inline={true}
              width={2}>
              <label
                id="CardEmployeeTimeAttendanceUX-label-34"
                style={{minWidth: "max-content"}}>
                {props.languageUX === "en" ? "to" : "ถึง"}
              </label>
              <div
                id="CardEmployeeTimeAttendanceUX-div-30"
                style={{width: "100%"}}>
                
                <DateTextBox
                  id="CardEmployeeTimeAttendanceUX-DateTextBox-32"
                  onChange={(value: any)=>props.onChangeFilter?.(null,{name: "course_start_date_to", value})}
                  value={props.filter?.course_start_date_to}>
                </DateTextBox>
              </div>
            </FormField>
            <FormField
              id="CardCourseListUX-FormField-41"
              inline={true}
              width={4}>
              <label
                id="CardCourseListUX-label-42"
                style={{minWidth: "max-content"}}>
                {props.languageUX === "en" ? "Status :" : "สถานะ :"}
              </label>
              <div
                id="CardCourseListUX-div-43"
                style={{width: "100%"}}>
                {props.statusFilter}
              </div>
            </FormField>
            <FormField
              id="CardEmployeeSummaryWorkHourUX-FormField-12"
              inline={true}
              style={{paddingRight: "0.5rem"}}>
              <div
                id="CardEmployeeSummaryWorkHourUX-div-13">
                {props.buttonSearch}
              </div>
            </FormField>
          </FormGroup>
        </Form>
        <div
          id="CardEmployeeSummaryWorkHourUX-div-15"
          style={{width: "100%"}}>
          {}
          <Table
            data={props.tableData}
            getTrProps={props.getTrProps}
            headers="ID,Course Subject,Type,Course period (hr),Start date,End date,Status,Approve Status,Attend/Abstain (hr.)"
            id="CardEmployeeTimeAttendanceUX-Table-39"
            keys="id,title,typeName,course_period,startDate,endDate,statusName,approveStatus,participatedAbstainHr"
            minRows={props.detail?3:14}
            showPagination={false}
            sortable={false}
            style={{height: props.detail?"calc(100vh - 41.5rem)":"calc(100vh - 12.5rem)"}}
            widths="^50,^200,^70,^95,^90,^90,^75,^75,^110">
          </Table>
        </div>
      </div>
    )
}


export default CardTrainingHistoryUX

export const screenPropsDefault = {"cannotPay":false,"cashAmountText":"14","citizenID":"31020000552","language":"EN","oweText":123,"patientNameAndHN":"HN: xxxxx นายทดสอบ","sumAmount":{"price":100,"reimbursable":42}}

/* Date Time : Thu Aug 28 2025 10:30:46 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{padding: \"10px\"}"
        }
      },
      "seq": 0
    },
    {
      "from": "semantic-ui-react",
      "id": 1,
      "name": "Form",
      "parent": 0,
      "props": {
        "className": {
          "type": "value",
          "value": "small"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-Form-1"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 2,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-FormGroup-2"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 6,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-FormField-6"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": null,
      "id": 7,
      "name": "label",
      "parent": 6,
      "props": {
        "children": {
          "type": "value",
          "value": "ค้นหาหลักสูตร :",
          "valueEN": "Search Course :"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-label-7"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 12,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-FormField-12"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{paddingRight: \"0.5rem\"}"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": null,
      "id": 13,
      "name": "div",
      "parent": 12,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSearch"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-div-13"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": null,
      "id": 15,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-div-15"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 20,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeTimeAttendanceUX-FormField-20"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 21,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeTimeAttendanceUX-FormField-21"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 22,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeTimeAttendanceUX-FormField-22"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 27,
      "name": "Dropdown",
      "parent": 20,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeTimeAttendanceUX-Dropdown-27"
        },
        "name": {
          "type": "value",
          "value": "training_type"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        },
        "options": {
          "type": "code",
          "value": "props.typeOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.filter?.training_type ?? \"\""
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": null,
      "id": 28,
      "name": "label",
      "parent": 20,
      "props": {
        "children": {
          "type": "value",
          "value": "พิมพ์ :",
          "valueEN": "Type :"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeTimeAttendanceUX-label-28"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 27,
      "void": false
    },
    {
      "from": null,
      "id": 29,
      "name": "div",
      "parent": 21,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeTimeAttendanceUX-div-29"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": null,
      "id": 30,
      "name": "div",
      "parent": 22,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeTimeAttendanceUX-div-30"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 34,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 31,
      "name": "DateTextBox",
      "parent": 29,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeTimeAttendanceUX-DateTextBox-31"
        },
        "onChange": {
          "type": "code",
          "value": "(value: any)=>props.onChangeFilter?.(null,{name: \"course_start_date_from\", value})"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "value": {
          "type": "code",
          "value": "props.filter?.course_start_date_from"
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 32,
      "name": "DateTextBox",
      "parent": 30,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeTimeAttendanceUX-DateTextBox-32"
        },
        "onChange": {
          "type": "code",
          "value": "(value: any)=>props.onChangeFilter?.(null,{name: \"course_start_date_to\", value})"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "value": {
          "type": "code",
          "value": "props.filter?.course_start_date_to"
        }
      },
      "seq": 32,
      "void": false
    },
    {
      "from": null,
      "id": 33,
      "name": "label",
      "parent": 21,
      "props": {
        "children": {
          "type": "value",
          "value": "หลักสูตร ตั้งแต่วันที่",
          "valueEN": "Course start date"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeTimeAttendanceUX-label-33"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 29,
      "void": false
    },
    {
      "from": null,
      "id": 34,
      "name": "label",
      "parent": 22,
      "props": {
        "children": {
          "type": "value",
          "value": "ถึง",
          "valueEN": "to"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeTimeAttendanceUX-label-34"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 30,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 39,
      "name": "Table",
      "parent": 15,
      "props": {
        "data": {
          "type": "code",
          "value": "props.tableData"
        },
        "getTrProps": {
          "type": "code",
          "value": "props.getTrProps"
        },
        "headers": {
          "type": "value",
          "value": "ID,Course Subject,Type,Course period (hr),Start date,End date,Status,Approve Status,Attend/Abstain (hr.)"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeTimeAttendanceUX-Table-39"
        },
        "keys": {
          "type": "value",
          "value": "id,title,typeName,course_period,startDate,endDate,statusName,approveStatus,participatedAbstainHr"
        },
        "minRows": {
          "type": "code",
          "value": "props.detail?3:14"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "sortable": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: props.detail?\"calc(100vh - 41.5rem)\":\"calc(100vh - 12.5rem)\"}"
        },
        "widths": {
          "type": "value",
          "value": "^50,^200,^70,^95,^90,^90,^75,^75,^110"
        }
      },
      "seq": 39,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 41,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCourseListUX-FormField-41"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": null,
      "id": 42,
      "name": "label",
      "parent": 41,
      "props": {
        "children": {
          "type": "value",
          "value": "สถานะ :",
          "valueEN": "Status :"
        },
        "id": {
          "type": "value",
          "value": "CardCourseListUX-label-42"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 42,
      "void": false
    },
    {
      "from": null,
      "id": 43,
      "name": "div",
      "parent": 41,
      "props": {
        "children": {
          "type": "code",
          "value": "props.statusFilter"
        },
        "id": {
          "type": "value",
          "value": "CardCourseListUX-div-43"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 43,
      "void": false
    },
    {
      "from": null,
      "id": 45,
      "name": "div",
      "parent": 6,
      "props": {
        "children": {
          "type": "code",
          "value": "props.courseSearchBox"
        },
        "id": {
          "type": "value",
          "value": "CardCourseListUX-div-45"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 45,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": false,
  "name": "CardTrainingHistoryUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "cannotPay": false,
    "cashAmountText": "14",
    "citizenID": "31020000552",
    "language": "EN",
    "oweText": 123,
    "patientNameAndHN": "HN: xxxxx นายทดสอบ",
    "sumAmount": {
      "price": 100,
      "reimbursable": 42
    }
  },
  "width": 75
}

*********************************************************************************** */
